module.exports = __webpack_public_path__ + "img/loading.dfd2683c.gif";